export class ApiException extends Error {
    code;
    body;
    headers;
    constructor(code, message, body, headers, cause) {
        super("HTTP-Code: " + code + "\nMessage: " + message + "\nBody: " + JSON.stringify(body, null, 2) + "\nHeaders: " +
            JSON.stringify(headers, null, 2), { cause });
        this.code = code;
        this.body = body;
        this.headers = headers;
    }
}
